import { PropertyWizardContext } from 'context/Context';
import { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import { navItems } from '../steps/data';
import { NavItem } from './NavItem';

export const NavWizard = () => {
  const { handleNavs, step } = useContext(PropertyWizardContext);

  return (
    <Nav>
      {navItems.map((item, index) => (
        <NavItem
          key={item.label}
          index={index + 1}
          icon={item.icon}
          label={item.label}
          handleNavs={handleNavs}
          step={step}
        />
      ))}
    </Nav>
  );
};
